import { render, staticRenderFns } from "./followWxInfo.vue?vue&type=template&id=99674b52&scoped=true&"
import script from "./followWxInfo.vue?vue&type=script&lang=js&"
export * from "./followWxInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99674b52",
  null
  
)

export default component.exports